import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Banner from '../../components/Banner/Banner';
import Solutions from '../../components/Solutions/Solutions';
import Join from '../../components/Join/Join';
import Footer from '../../components/Footer/Footer';
import ContactSection from '../../components/ContactSection/ContactSection';

import './Home.css';
import { 
  FaGlobeAsia, 
  FaFileContract, 
  FaChartLine, 
  FaChartBar,
  FaDesktop,
  FaShieldAlt,
  FaNetworkWired,
  FaCalculator
} from 'react-icons/fa';

// 新增的公司介绍组件
const CompanyIntro = () => {
  return (
    <div className="pt-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-left">
          <p className="text-lg text-gray-700 leading-relaxed" style={{textIndent: '2em'}}>
            海南数瑞科技是一家致力于跨境贸易、海关报关、投资与风险管理、证券市场解决方案的综合性科技企业。公司依托自研的跨境贸易智能管理平台、合规风控系统、进出口自动化报关与税务筹划工具、以及投资/证券领域的智能分析与决策产品，帮助全球贸易商和投资机构在高效管理业务的同时规避复杂风险。 凭借对国际贸易政策、多国关税法规以及金融市场的深度理解，海南数瑞科技为客户提供从进出口业务规划、海外物流追踪、财务结算与税务筹划、海关合规审查、投融资风控到股票与证券动态监测的全流程数字化软件解决方案。坐落于海南自由贸易港，团队由资深外贸专家、海关政策专员、金融量化分析师以及软件工程师共同组成，借助自贸港的政策与资源优势，持续为企业与机构赋能，实现全球业务的智慧化管理。
          </p>
        </div>
      </div>
    </div>
  );
};

const Home = () => {
  const solutionsCards = {
    title: "软件解决方案",
    subtitle: "",
    cards: [
    {
      icon: <FaDesktop className="w-12 h-12" style={{ color: 'var(--primary-color)' }} />,
      title: '跨境贸易&进出口管理',
      path: '/trade',
      description: '智能化跨境贸易管理系统，提供一站式贸易流程管理，实现业务全程数字化监控与优化。'
    },
    {
      icon: <FaShieldAlt className="w-12 h-12" style={{ color: 'var(--primary-color)' }} />,
      title: '海关报关，进出口申报',
      path: '/customs', 
      description: '全面的贸易合规检查与风险评估系统，确保贸易活动符合国际规范，有效防范贸易风险。'
    },
    {
      icon: <FaNetworkWired className="w-12 h-12" style={{ color: 'var(--primary-color)' }} />,
      title: '投资与风险管理',
      path: '/investment',
      description: '整合供应链各环节资源，提供实时物流追踪，优化供应链协同效率。'
    },
    {
      icon: <FaCalculator className="w-12 h-12" style={{ color: 'var(--primary-color)' }} />,
      title: '股票&证券',
      path: '/stock',
      description: '专业的国际贸易财务处理系统，提供精准的关税计算、汇率管理及财务结算服务。'
    }
  ]
  };
  return (
    <div className="home flex flex-col min-h-screen">
      <Navbar />
      <Banner />
      <CompanyIntro />
      <Solutions {...solutionsCards} />
      <ContactSection />
      
      {/* <Join /> */}
      <div className='mt-auto'  style={{backgroundColor: '#f8f9fa'}}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Home; 